module.exports = __webpack_public_path__ + "img/module-thumb.21a8c7c0.jpg";